"use client";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay } from "swiper/modules";
import { HLSPlayer } from "@/src/components/custom/VideoPlayer/HLSPlayer";
import { X } from "lucide-react";

// Utility to detect and extract YouTube video ID
const getYouTubeVideoId = (url: string): string | null => {
  if (!url) return null;

  // Match various YouTube URL formats
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&\n?#]+)/,
    /^([a-zA-Z0-9_-]{11})$/, // Direct video ID
  ];

  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }

  return null;
};

const isYouTubeUrl = (url: string): boolean => {
  return !!getYouTubeVideoId(url);
};
// interface VideoHighlight {
//   id: string;
//   timestamp: string;
//   frame_video_url: string;
//   chunk_video_url: string;
//   label: string;
//   camera_name: string;
//   zone_name: string;
// }

export default function VideoHighlights({ open, onOpenChange, video_url, image }: { open: boolean, onOpenChange: (open: boolean) => void, video_url: string, image: string }) {
  const isYouTube = isYouTubeUrl(video_url);
  const youtubeVideoId = isYouTube ? getYouTubeVideoId(video_url) : null;

  return (
    <div>
      {/* Video Modal */}
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogHeader hidden>
          <DialogTitle>Video</DialogTitle>
        </DialogHeader>
        <DialogContent
          className="min-w-[60%] max-h-[80%] aspect-[16/9] max-w-[80vw] bg-black p-0 border-0 overflow-hidden"
          showCloseButton={false}
        >
          <DialogClose className="absolute top-2 right-2 z-80 bg-white hover:bg-gray-200 transition-all delay-50 duration-300 ease-in-out hover:scale-110 text-black p-2 rounded-full shadow-lg" >
            <X className="h-3 w-3" />
          </DialogClose>
          <div className="w-full h-full bg-black">
            {video_url && (
              <>
                {isYouTube && youtubeVideoId ? (
                  // YouTube iframe embed
                  <iframe
                    className="w-full h-full"
                    src={`https://www.youtube.com/embed/${youtubeVideoId}?autoplay=0&controls=1&rel=0`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />
                ) : (
                  // HLS/m3u8 video player
                  <HLSPlayer
                    hlsSrc={video_url}
                    posterSrc={image || "https://media.istockphoto.com/id/2184123695/photo/man-and-robot-handshake-ai-document-management-system-hologram-hud.jpg?s=2048x2048&w=is&k=20&c=AyK5eEAc5Z8ajv375Q_edqANd1dRnS0qyMS6eMPR5RY="}
                  />
                )}
              </>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

